import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import '../../content/css/MissingConcepts.css';

export default class MissingConceptTextBox extends Component {

    render() {
        let title = !this.props.warnWhenMissing ? "This is a missing key clause!" : this.props.title;
        let text = !this.props.warnWhenMissing ? "To see what this clause is about you need to become a customer." : this.props.text;
        let isActiveClass = !this.props.warnWhenMissing ? " disabled" : "";
        return (
            <div className={`missing-concept-box${isActiveClass}`}>
                <div className="box-header">
                    <span className="title"><strong>{title}</strong></span>
                </div>
                <ReactMarkdown classname="box-content" source={text} escapeHtml={false} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MissingConcepts/MissingConceptTextBox.js